import type { ClassDefinition } from '../../shared/game/class-types.js';

// Commander 3.0 draft, level 1. Later levels (Combat Dice, Orders, subclasses) are not implemented yet.
export const commander: ClassDefinition = {
  id: 'commander', name: 'Commander',
  summary: 'A highly tactical, teamwork-focused melee class and a party’s force multiplier.',
  keyStats: ['strength', 'intelligence'], hitDie: 10, startingHp: 17,
  saves: { advantage: ['strength'], disadvantage: ['dexterity'] },
  armor: ['mail', 'shield'], weapons: 'all',
  startingGear: ['Short Sword', 'Javelins (4)', 'Rusty Mail'],
  abilities: [{
    id: 'coordinated-strike', name: 'Coordinated Strike', level: 1, actions: 0, usesPerEncounter: 1, target: 'ally', combatOnly: true, autocast: true,
    description: 'You and an ally within Reach 6 both immediately make a weapon strike for free. Once per encounter.',
  }],
  passives: [],
};
